import React from 'react';
import { PropTypes } from 'prop-types';

import './skiingFramework.scss';

import SecondaryNavigation from 'components/secondaryNavigation/SecondaryNavigation';

function SkiingFramework({
  locationId,
  translations,
  location,
  lastLevelPath,
  secondLastLevelPath,
  children
}) {
  if (!translations || !location) {
    return null;
  }

  const subpages = [
    {
      name: translations.tabs.lifts,
      url: `/skiing/${locationId}`,
      isActive: lastLevelPath !== 'weather' && lastLevelPath !== 'webcam' && secondLastLevelPath !== 'webcam',
    },

/*    
    { 
      name: translations.tabs.weather,
      url: `/skiing/${locationId}/weather`,
      isActive: lastLevelPath === 'weather',
    },
    */
    {
      name: translations.tabs.webcam,
      url: `/skiing/${locationId}/webcam`,
      isActive: lastLevelPath === 'webcam' || secondLastLevelPath === 'webcam',
    },
  ];

  return (
    <div className="skiing-content">
      <SecondaryNavigation options={subpages} />

      {children}
    </div>
  );
}

SkiingFramework.propTypes = {
  translations: PropTypes.object,
  location: PropTypes.object,
};

export default SkiingFramework;
